module.exports = __webpack_public_path__ + "img/icons_35.68566520.png";